import React from 'react';
import { FileText, CheckSquare, Printer, Truck } from 'lucide-react';
const steps = [{
  icon: FileText,
  title: 'Request Quote',
  description: 'Fill out our simple form with your artwork and garment preferences.'
}, {
  icon: CheckSquare,
  title: 'Approve Proof',
  description: 'We send a digital mockup for your approval before any ink touches fabric.'
}, {
  icon: Printer,
  title: 'Production',
  description: 'Our expert team prints your order using premium inks and equipment.'
}, {
  icon: Truck,
  title: 'Fast Delivery',
  description: 'We ship your order or have it ready for local pickup on time, every time.'
}];
export function Process() {
  return <section id="process" className="py-24 bg-blue-900 text-white relative overflow-hidden" data-id="element-161">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-162">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-red-600 blur-3xl" data-id="element-163"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-blue-400 blur-3xl" data-id="element-164"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-165">
        <div className="text-center mb-16" data-id="element-166">
          <h2 className="text-red-400 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-167">
            How It Works
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-white" data-id="element-168">
            Simple 4-Step Process
          </h3>
        </div>

        <div className="relative" data-id="element-169">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-blue-800" data-id="element-170"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-171">
            {steps.map((step, index) => <div key={index} className="relative flex flex-col items-center text-center group" data-id="element-172">
                <div className="w-24 h-24 rounded-full bg-blue-800 border-4 border-blue-900 flex items-center justify-center mb-6 relative z-10 group-hover:bg-red-600 group-hover:border-red-700 transition-colors duration-300 shadow-xl" data-id="element-173">
                  <step.icon className="h-10 w-10 text-white" data-id="element-174" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-white text-blue-900 flex items-center justify-center font-bold text-sm border-2 border-blue-900" data-id="element-175">
                    {index + 1}
                  </div>
                </div>
                <h4 className="text-xl font-bold text-white mb-3" data-id="element-176">
                  {step.title}
                </h4>
                <p className="text-blue-200 leading-relaxed text-sm" data-id="element-177">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}